import { FilePlusIcon } from "lucide-react";
import * as React from "react";
import { DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { useLinkFileMutation } from "@/api/files";
import { Item } from "@/types/fse";
import { FilesSelectTree } from "@/components/app/files-select-tree";
import { toast } from "react-toastify";

interface Props {
  currentFolderId: string;
  setIsOpen: (isOpen: boolean) => void;
}

export const AddFilesModalContent: React.FC<Props> = ({ currentFolderId, setIsOpen }) => {
  const handleClose = () => {
    setIsOpen(false);
  };
  const [added, setAdded] = React.useState<string[]>([]);

  const [linkFile] = useLinkFileMutation();

  const handleFileAction = async (item: Item) => {
    await linkFile({ fse_id: currentFolderId, linked_fse_ids: [item.id] }).unwrap();
    setAdded(prev => [...prev, item.id]);

    toast.success(`${item.name} has been added successfully.`);
  };

  return (
    <DialogContent className="flex h-[80vh] max-h-[600px] w-full max-w-[90vw] flex-grow flex-col">
      <DialogHeader>
        <DialogTitle>Add Files</DialogTitle>
      </DialogHeader>
      <div className="flex flex-grow flex-col space-y-4 overflow-hidden">
        <FilesSelectTree
          onAction={handleFileAction}
          actionButton={(item: Item) => (
            <Button
              variant="secondary"
              size="sm"
              className="w-full text-xs sm:w-auto"
              type="button"
              disabled={added.includes(item.id)}
            >
              <FilePlusIcon className="mr-1 h-4 w-4" />
              {added.includes(item.id) ? "Added" : "Add File"}
            </Button>
          )}
          showFiles={true}
          showFolders={true}
          filterCurrentFolder={currentFolderId}
        />
      </div>
      <div className="mt-4 flex justify-between">
        <Button variant="outline" onClick={handleClose}>
          Cancel
        </Button>
      </div>
    </DialogContent>
  );
};
